module.exports = __webpack_public_path__ + "static/media/marker.11721695.svg";